import { programPlannerRoutes } from './program_planner/routes';
import { projectTrackerRoutes } from './project_tracker/routes';
import { stageConfigRoutes } from './stage_config/routes';
import { dashboardRoutes } from './dashboard/routes';

export const spartaPlannerRoutes = [
    ...programPlannerRoutes,
    ...projectTrackerRoutes,
    ...stageConfigRoutes,
    ...dashboardRoutes,
];
